import styled from 'styled-components';
import {
  CardContent,
  CardActionArea as CardActionAreaComponent,
} from '@prisjakt/ui/card';
import { layout, media } from 'src/components/base';
import { RowCard } from '@prisjakt/ui/card/variants';
import { Row } from '@prisjakt/ui/list/variants';

export const CardActionArea = styled(CardActionAreaComponent)`
  cursor: pointer;
  width: 100%;
`;

export const Main = styled.div`
  display: grid;
  grid-template-columns: auto 3fr 1fr;
  width: 100%;

  ${media.mediumDown`
    grid-template-columns: auto minmax(0, 1fr);
    grid-template-rows: auto 1fr;
  `};
`;

export const MainContent = styled(CardContent)`
  text-align: initial;
`;

export const PriceContent = styled(CardContent)`
  align-items: flex-end;
  justify-content: space-between;
  flex: 1 1 auto;

  ${media.mediumDown`
    display: none;
  `}
`;

export const Card = styled(RowCard)`
  ${media.mediumDown`
    ${PriceContent} {
      padding-top: 0;
    }
  `}
`;

type ImageWrapperProps = {
  $size: string;
};

export const ImageWrapper = styled(CardContent)<ImageWrapperProps>`
  && {
    position: relative;
    height: fit-content;
    width: ${p => p.$size};
    padding: 0;
    margin: ${layout.measurements.spacing100};
  }
`;

export const BrandLogo = styled.img`
  position: absolute;
  z-index: 2;
  bottom: ${layout.measurements.spacing100};
  max-height: 24px;
  background: rgba(255, 255, 255, 0.72);
  border-radius: 4px;
  padding: 2px;

  &:not(:last-child) {
    margin: 0;
  }
`;

export const RowWrapper = styled(Row)`
  align-items: center;
  flex-wrap: wrap;

  > * {
    margin: 0;
    max-width: max-content;

    &:not(:last-child) {
      margin-right: ${layout.measurements.spacing050};
    }
  }
`;

export const Tag = styled.div`
  background: ${p => p.theme.bg.secondary};
  padding: 2px ${layout.measurements.spacing025};
  border-radius: 3px;
  width: max-content;
`;

export const PriceRowWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  white-space: nowrap;
  max-width: 100%;

  ${media.mediumDown`
    align-items: flex-start;
    width: 100%;
  `}
`;

export const CTAText = styled(Row)`
  && {
    align-items: center;
    flex: 0 1 auto;
    margin-top: auto;
  }

  svg {
    fill: ${p => p.theme.icons.callToAction};
  }

  ${media.mediumDown`
    display: none;
  `};
`;

export const PriceTextWrapper = styled(Row)`
  align-items: baseline;
  flex-wrap: wrap;

  /* stylelint-disable */
  > * {
    flex: 0 1 auto;
  }
  /* stylelint-enable */
`;
